import * as Yup from "yup";
import dayjs from "dayjs";

// const NATIONALITY = {
//   DOMESTIC: "domestic",
//   FOREIGNER: "foreigner",
// };

export const initialValues = {
  employeeStatusId: null,
  employeeTypeId: null,
  supervisor: null,
  dateContractExpire: dayjs('YYYY-MM-DD'),
  holidayCalendarId: null,
  manpowerType: null,
  recordTime: null,
  companyName: null,
  departmentId: null,
  positionId: null,
  employeeNo: null,
  workLocation: null,
  shiftId: null,
  employmentDate: dayjs('YYYY-MM-DD'),
  employmentTypeId: null,
  paymentMethod: null,
  bankAccountNo: null,
  daysProbation: 119,
  extensionProbation: "N",
  reasonOfSeparation: null
};

const EmploymentInfoSchema = Yup.object().shape({
  employeeStatusId: Yup.string().required("Please select employee status."),
  employeeTypeId: Yup.string().required("Please select employee type."),
  manpowerType: Yup.string().required("Please select manpowerType."),
  recordTime: Yup.string().required("Please select recordTime."),
  companyName: Yup.string().required("Please select company name."),
  departmentId: Yup.string().required("Please select department."),
  positionId: Yup.string().required("Please select position."),
  employeeNo: Yup.string().required("Please enter  employee no."),
  // shiftId: Yup.string().required("Please select shift."),
  employmentDate: Yup.date().required("Please select employment date."),
  employmentTypeId: Yup.string().required("Please select employment type."),
});

export default EmploymentInfoSchema;
